import React  from 'react';
import FormatTableApp from "../Functionality/FormatTableApp";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import CustomTable from "../../../../../components/table/CustomTable";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import CreateFormats from "../../Formats/CreateFormats";
import DeleteModal from "../../../../Modals/DeleteModal";
import DividerWithText from "../../../../../components/DividerWithText";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const FormatTable = ({ defaultSioList }) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        setDeleteFormatShow,
        showCreateFormatModal,
        setShowCreateFormatModal,
        deleteFormatShow,
        isAllChecked,
        setModified,
        deleteSelectedFormat,
        handleCheckboxChange,
        handleDeleteAll,
        handleAddButtonClick,
    } = FormatTableApp({
        defaultSioList
    });

    return (
        <>
                <div className='row mt-4'>
                    <DividerWithText title={t('format')} />
                    <div className='d-flex justify-content-end mb-2'>
                        <ButtonAction
                            id='btn_ft_delete_format'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            Icon={TrashOutlineIcon}
                            onClick={() => {
                                setDeleteFormatShow(true);
                            }}
                        />
                    </div>
                    <CustomTable
                        tableId={tableId}
                        checkbox={true}
                        checkboxTitle={"de_/_select_all"}
                        isAllChecked={isAllChecked}
                        onChangeCheckbox={handleDeleteAll}
                        handleCheckboxChange={handleCheckboxChange}
                        selectedList={selectedList}
                        thead={thead}
                        tbody={tbody}
                        columnActions={false}
                        withoutHeight={true}
                    />
                    <div className='my-2'>
                        <ButtonLargeTransparent
                            id="btn_ft_create_format"
                            click={handleAddButtonClick}
                            text={t("create_format")}
                        />
                    </div>
                </div>

            {showCreateFormatModal &&
                <CreateFormats
                    controllerId={id}
                    show={showCreateFormatModal}
                    onHide={() => setShowCreateFormatModal(false)}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteFormatShow}
                onHide={() => setDeleteFormatShow(false)}
                onClickFn={() => deleteSelectedFormat()}
                data={selectedList}
                title_modal={t('delete_format')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('format')}
            />
        </>
    );
};

export default FormatTable;
